import React from 'react';
import { ArrowLeft, Shield, Star } from 'lucide-react';

const PurchaseOptionsFallback: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-dark-950 via-dark-900 to-dark-950">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Back Button */}
        <div className="pt-4 mb-4 flex items-center text-gray-400">
          <ArrowLeft className="w-5 h-5 mr-2" />
          <div className="h-4 bg-gray-700 rounded w-24 animate-pulse" />
        </div>

        {/* Creator Hero Section */}
        <div className="pb-6">
          <div className="flex items-center justify-center gap-6 mb-4">
            {/* Avatar */}
            <div className="relative">
              <div className="w-20 h-20 bg-gray-700 rounded-full animate-pulse" />
              <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center border-2 border-dark-900">
                <Shield className="w-3 h-3 text-white" />
              </div>
            </div>

            {/* Creator Info */}
            <div className="text-left">
              <div className="h-6 bg-gray-700 rounded w-32 mb-2 animate-pulse" />

              {/* Badges and Rating */}
              <div className="flex items-center gap-3 mb-2 flex-wrap">
                <div className="h-5 bg-gray-700 rounded-full w-16 animate-pulse" />
                <div className="h-5 bg-gray-700 rounded-full w-12 animate-pulse" />
                <div className="flex items-center space-x-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-3.5 h-3.5 text-gray-600" />
                  ))}
                </div>
              </div>

              {/* Stats */}
              <div className="flex items-center gap-4 text-xs">
                <div className="h-3 bg-gray-700 rounded w-16 animate-pulse" />
                <div className="h-3 bg-gray-700 rounded w-20 animate-pulse" />
              </div>
            </div>
          </div>

          {/* Bio */}
          <div className="text-center max-w-2xl mx-auto mb-3">
            <div className="h-4 bg-gray-700 rounded w-3/4 mx-auto animate-pulse" />
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        {/* Pricing Section Header */}
        <div className="text-center mb-6">
          <div className="h-8 bg-gray-700 rounded w-48 mx-auto mb-2 animate-pulse" />
          <div className="h-4 bg-gray-700 rounded w-64 mx-auto animate-pulse" />
        </div>

        {/* Subscription Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          {Array.from({ length: 4 }).map((_, index) => (
            <div
              key={index}
              className="bg-dark-800 border border-gray-700 rounded-2xl p-6 animate-pulse"
            >
              {/* Title */}
              <div className="text-center mb-4">
                <div className="h-6 bg-gray-700 rounded w-20 mx-auto mb-1" />
                <div className="h-4 bg-gray-700 rounded w-16 mx-auto" />
              </div>

              {/* Price */}
              <div className="text-center mb-6">
                <div className="h-12 bg-gray-700 rounded w-24 mx-auto" />
              </div>

              {/* Button */}
              <div className="h-12 bg-gray-700 rounded" />
            </div>
          ))}
        </div>

        {/* Features Section */}
        <div className="bg-dark-900 rounded-xl p-6 border border-dark-700">
          <div className="h-6 bg-gray-700 rounded w-32 mb-4 animate-pulse" />
          <div className="grid md:grid-cols-2 gap-4">
            {Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="flex items-start">
                <div className="w-5 h-5 bg-gray-700 rounded mr-3 mt-0.5 animate-pulse" />
                <div className="flex-1">
                  <div className="h-4 bg-gray-700 rounded w-24 mb-1 animate-pulse" />
                  <div className="h-3 bg-gray-700 rounded w-32 animate-pulse" />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Loading message */}
        <div className="text-center mt-8">
          <div className="inline-flex items-center space-x-2 text-gray-400">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-neon-green"></div>
            <span>Loading purchase options...</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseOptionsFallback;